import commonJs from './common/app';
import initThematicBlockRenault from './renault/cpThematicBlockRenault';

document.addEventListener('DOMContentLoaded', () => {
  commonJs();
  initThematicBlockRenault();
});
